//
//
//
//
//
//
//
//

import { ActionBase, Typography } from '@backmarket/design-system'

import { tw } from '@core/tailwind'

/**
 * This component makes use of the old ActionTiny styles
 * since the new variants don't play well with the Pagination result
 *
 * Let's keep in mind that this code uses legacy design tokens and
 * that it should be integrated into the desig system
 *
 * TODO: DSB-1199
 */
export default {
  components: { ActionBase, Typography },
  inheritAttrs: false,
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classNames() {
      const shared = tw`
      inline-flex items-center justify-center
      px-3 py-2 max-w-full
      border-0 rounded-2
      no-underline
      cursor-pointer
      disabled:cursor-not-allowed
      focus:outline-none
      motion-safe:transition motion-safe:ease-in motion-safe:duration-300
    `

      const defaultClassNames = tw`
        bg-transparent text-black
        disabled:text-grey-400 disabled:bg-transparent
        focus:bg-grey-300 hover:bg-grey-200
      `

      const activeClassNames = tw`
        bg-grey-200 text-black
        disabled:text-grey-400 disabled:bg-transparent
        focus:bg-grey-300 hover:bg-grey-300
      `

      return [shared, this.isActive ? activeClassNames : defaultClassNames]
    },
  },
}
